import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'
import { Box, Button, Flex, HStack, Heading, Select, Spacer } from '@chakra-ui/react'
import { IoIosAddCircleOutline } from 'react-icons/io'

const AddButton = ({ onClick }) => {
  return (
    <Box _hover={{ cursor: 'pointer' }} color="teal.400" justifyContent={'center'} w="24px">
      <IoIosAddCircleOutline
        size={24}
        onClick={(e) => {
          e.stopPropagation()
          onClick()
        }}
      />
    </Box>
  )
}

export default AddButton
